import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderOpen"><Path d="M8 11L5.5 19.5H19.75L22.25 11H20.5H8Z" stroke="currentColor" strokeLinecap="round"/><Path d="M5.5 19.5H2.5V3.5H10L12 6.5H20.5V11" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFolderOpen;
